import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import * as Analytics from 'analytics/analytics'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'

interface Props {
  title: React.ReactNode
  children: React.ReactNode
  trackingName: string
  subtitle?: React.ReactNode
  viewAllTo?: string
  viewAllText?: string
  ref?: React.Ref<HTMLDivElement | null>
}

function MerchandiseCarouselSection(props: Props) {
  const intl = useIntl()
  const defaultViewAllText = intl.formatMessage({
    id: 'tqUizqzw8D',
    defaultMessage: 'Shop all',
    description: 'Default button text to view all items in a merchandise carousel',
  })
  const { title, children, trackingName, subtitle, viewAllTo, viewAllText = defaultViewAllText, ref } = props

  const onViewAllClick = useCallback(() => {
    Analytics.trackClientEvent({
      subject: `merchandise-carousel-${trackingName}-viewall`,
      action: 'click',
      category: 'shop',
      type: 'interaction',
    })
  }, [trackingName])

  return <Sheet padding="40 0" ref={ref}>
    <VerticalSpacer gap={32}>
      <LayoutContainer>
        <Group
          direction="horizontal"
          gap={16}
          horizontalAlign="space-between"
          verticalAlign="center"
        >
          <VerticalSpacer gap={4}>
            <Heading variant="heading2">{title}</Heading>
            {!!subtitle && <BodyText variant="large">{subtitle}</BodyText>}
          </VerticalSpacer>
          {viewAllTo && <TextButton
            kind="tertiary"
            size="large"
            to={viewAllTo}
            horizontalOutdent="end"
            onClick={onViewAllClick}
          >
            {viewAllText}
          </TextButton>}
        </Group>
      </LayoutContainer>
      <div>
        {children}
      </div>
    </VerticalSpacer>
  </Sheet>
}

export default MerchandiseCarouselSection
